//AWS API Gateway endpoint for the AppSync service
export const API_GATEWAY = process.env.REACT_APP_API_GATEWAY;
export const API_GATEWAY_NEW = process.env.REACT_APP_API_GATEWAY_NEW;
export const API_GATEWAY2 = process.env.REACT_APP_API_GATEWAY2;
//AWS AppSync authentication type
export const APPSYNC_AUTH_TYPE = process.env.REACT_APP_APPSYNC_AUTH_TYPE;
//AWS AppSync endpoint
export const APPSYNC_ENDPOINT = process.env.REACT_APP_APPSYNC_ENDPOINT;
//AWS AppSyncregion
export const APPSYNC_REGION = process.env.REACT_APP_APPSYNC_REGION;
//Domain for Amplify cookie storage
export const AUTH_COOKIE_DOMAIN = process.env.REACT_APP_AUTH_COOKIE_DOMAIN;
//Cookie expiry time for Amplify cookie storage
export const AUTH_COOKIE_EXPIRES = parseInt(
  process.env.REACT_APP_AUTH_COOKIE_EXPIRES
);
//Path for Amplify cookie storage
export const AUTH_COOKIE_PATH = process.env.REACT_APP_AUTH_COOKIE_PATH;
//The key used to store our temporary OAuth token in localStorage
export const AUTH_TOKEN_KEY = process.env.REACT_APP_AUTH_TOKEN_KEY;
//AWS Cognito Identity Pool ID
export const AWS_COGNITO_IDENTITY_POOL_ID =
  process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID;
//AWS Cognito Identity Pool ID
export const AWS_COGNITO_REGION = process.env.REACT_APP_AWS_COGNITO_REGION;
//AWS Cognito User Pool ID
export const AWS_COGNITO_USER_POOL_ID =
  process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID;
//AWS Cognito User Pool Client ID
export const AWS_COGNITO_USER_POOL_CLIENT_ID =
  process.env.REACT_APP_AWS_COGNITO_USER_POOL_CLIENT_ID;
//Set to true to enable an embedded app or false to disable it
export const ENABLED_EMBEDDED = process.env.REACT_APP_ENABLED_EMBEDDED;
//Shopify API Key
export const SHOPIFY_API_KEY = process.env.REACT_APP_SHOPIFY_API_KEY;
// The app permalink is used for redirection you can found it here: shop.myshopify/admin/apps/{app permalink}
export const SHOPIFY_APP_PERMALINK =
  process.env.REACT_APP_SHOPIFY_APP_PERMALINK;
//Embedded app force redirect
export const SHOPIFY_EMBEDDED_FORCE_REDIRECT = JSON.parse(
  process.env.REACT_APP_SHOPIFY_EMBEDDED_FORCE_REDIRECT
);
export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const SCOPE = process.env.REACT_APP_SCOPE;
export const APP_DEV = JSON.parse(process.env.REACT_APP_DEV);
const pushing_time = "1734319322261";
